/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

(() => {
  const root = document.documentElement;

  const header = document.querySelector('.theme__header');
  const announce = document.querySelector('.announcement__wrapper');

  const EXTRA_GAP = 20;
  const UPDATE_THRESHOLD = 3; // ← 3px未満の変化は無視（ここ調整）

  const visibleHeight = (el) => {
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    const top = Math.max(0, r.top);
    const bottom = Math.min(window.innerHeight, r.bottom);
    return Math.max(0, bottom - top);
  };

  let ticking = false;
  let last = null;

  const apply = (offset) => {
    root.style.setProperty('--sticky-offset', `${offset}px`);
    root.dataset.stickyOffset = String(offset);
  };

  const setOffset = () => {
    const h = visibleHeight(header);
    const a = visibleHeight(announce);

    // まずは小数の揺れを消す（floor推奨：増えたり減ったりしにくい）
    const next = Math.floor(h + a + EXTRA_GAP);

    if (last === null || Math.abs(next - last) >= UPDATE_THRESHOLD) {
      last = next;
      apply(next);
    }
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      setOffset();
      ticking = false;
    });
  };

  setOffset();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });

  const ro = new ResizeObserver(() => setOffset());
  header && ro.observe(header);
  announce && ro.observe(announce);
})();
